import { render, staticRenderFns } from "./tabelaConsumoRacaoSearch.vue?vue&type=template&id=795bbc5a&scoped=true&"
import script from "./tabelaConsumoRacaoSearch.vue?vue&type=script&lang=js&"
export * from "./tabelaConsumoRacaoSearch.vue?vue&type=script&lang=js&"
import style0 from "./tabelaConsumoRacaoSearch.vue?vue&type=style&index=0&id=795bbc5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795bbc5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VFlex,VLayout,VTextField})
